/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Hubspot_Reading_Not_DecidableInputs */

const en_error_hubspot_reading_not_decidable = /** @type {(inputs: Error_Hubspot_Reading_Not_DecidableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The reading of HubSpot is already archived or discarded, or it lost parts and can only be discarded.`)
};

/**
* | output |
* | --- |
* | "The reading of HubSpot is already archived or discarded, or it lost parts and can only be discarded." |
*
* @param {Error_Hubspot_Reading_Not_DecidableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_hubspot_reading_not_decidable = /** @type {((inputs?: Error_Hubspot_Reading_Not_DecidableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Hubspot_Reading_Not_DecidableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_hubspot_reading_not_decidable(inputs)
});